<template>
    <ol v-if="page" v-show="breadcrumbItems.length > 1" class="page-breadcrumbs">
        <li
            v-for="(item, index) in breadcrumbItems"
            :key="index"
            class="page-breadcrumbs__item"
            :class="{ 'is-current': item.isCurrent }"
        >
            <LocalizedLink v-if="!item.isCurrent" :to="item.target">
                <span>{{ item.label }}</span>
            </LocalizedLink>

            <!-- eslint-disable-next-line @intlify/vue-i18n/no-raw-text -->
            <span v-if="!item.isCurrent" class="item-divider">/</span>

            <span v-if="item.isCurrent">{{ item.label }}</span>
        </li>
    </ol>
</template>

<script>
export default {
    props: {
        page: {
            type: Object,
            default: null,
        },
    },
    computed: {
        breadcrumbItems() {
            const { page } = this;

            const items = [];

            let ancestor = page.parent;

            while (ancestor) {
                items.unshift({
                    target: ancestor.path,
                    label: ancestor.breadcrumbTitle,
                });
                ancestor = ancestor.parent;
            }

            items.push({
                isCurrent: true,
                label: page.breadcrumbTitle,
            });

            return items;
        },
    },
};
</script>

<style lang="scss">
@import '@/sass/_variables.scss';

.page-breadcrumbs {
    @include font-size(16px);

    &__item {
        color: $secondary-text-color;
        display: inline-block;
        margin-right: 4px;
    }

    .item-divider {
        color: $primary;
    }
}
</style>
